"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSvgIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function createSvgIcon(path, displayName) {
  const Component = (props, ref) => /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    ref: ref
  }, props), path);

  Component.displayName = `${displayName}Icon`;
  return /*#__PURE__*/_react.default.memo( /*#__PURE__*/_react.default.forwardRef(Component));
}